import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const ColorButton = withStyles((theme) => ({
	root: {
		// color: theme.palette.getContrastText(purple[500]), // ERRORBAG 1
		backgroundColor: '#EB505E',
		boxShadow: '4px 4px 16px rgba(68, 113, 209, 0.04)',
		borderRadius: '48px',
		textTransform: 'none',
		// height: '100%',
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: '500',
		fontSize: '18px',
		lineHeight: '23px',
		color: '#FFFFFF',                                     //// ERRORBAG 1
		paddingLeft: theme.spacing(3),
		paddingRight: theme.spacing(3),
		"&:hover": {
			backgroundColor: '#EB505E'
		}
	},
}))(Button);

export default function PrimaryButton(props) {

	return (
		<ColorButton disabled={props.disabled} variant="contained" onClick={props.onClick} style={{ lineHeight: (props.height - 12) + 'px', minWidth: props.width ? props.width : 'unset' }} /* className={classes.margin} */>
			{props.text}
		</ColorButton>
	);
}